import React, {Fragment, useState} from "react";

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const initialDaysModel = (singleLocationMode) => days.map(day => {
  return {
    name: day,
    selected: singleLocationMode, // Only require selecting hours for bulk edit mode
    open24Hours: false,
    isClosed: false,
    hasNone: false,
    hourBlocks: [
      {
        openTime: "",
        closeTime: ""
      }
    ]
  }
});

import './BulkLocationEditorHours.css'

function BulkLocationEditorHours({setFormIsInvalid, createMode, combinedLocationServicesMap, singleLocationMode, updateLocationPatchSection, locationPatchHours}) {

  const defaultHourBlock = {
    openTime: "",
    closeTime: ""
  };

  const open24HoursBlock = {
    openTime: "00:00",
    closeTime: "24:00"
  };

  // Fill in day model with the data from the location patch
  const _state = initialDaysModel(singleLocationMode).map(dayModel => {
    const maybeActivelyEditedDay = locationPatchHours.find(day => day.name === dayModel.name);


    const dayBeforeAddingDefaultHours = !!maybeActivelyEditedDay ? {
      selected: dayModel.selected,
      ...maybeActivelyEditedDay
    } : dayModel;

    return {
      ...dayBeforeAddingDefaultHours,
      hourBlocks: (dayBeforeAddingDefaultHours.hourBlocks.length === 0 ? [defaultHourBlock] : dayBeforeAddingDefaultHours.hourBlocks)
    }
  });

  const [daysModel, setDaysModel] = useState(_state);

  const cleanDaysForPatch = (dayModel) => {
    return dayModel.filter(day => {
      return (day.selected === true || singleLocationMode) && (
        day.isClosed || day.hasNone || (!!day.hourBlocks[0] && day.hourBlocks[0].openTime !== "" && day.hourBlocks[0].closeTime !== "")
      )
    }).map(day => ({
      ...day,
      hourBlocks: day.hourBlocks.filter(hourBlock => day.hasNone || hourBlock.openTime !== "" && hourBlock.closeTime !== "")
    }))
  };

  const setDaySelected = (day) => (event) => {
    const selected = event.target.checked;

    const updatedDaysModel = daysModel.map(dayModel => {
      return day.name === dayModel.name ? {...dayModel, selected} : dayModel
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const setAllDaysSameAsMonday = () => (event) => {
    if(singleLocationMode || $("#Monday").prop("checked")) {
      daysModel.map(dayModel => {
        if (dayModel.name === "Monday") {
          const isMondayClosed = dayModel.isClosed || false
          const mondayHasNone = dayModel.hasNone || false
          const mondayOpen24Hours = dayModel.open24Hours || false
          const mondayHours = dayModel.hourBlocks
          const updatedDaysModel = daysModel.map(currentDay => {
            // Make the checkboxes match the values
            $("#open24hours-" + currentDay.name).prop("checked", mondayOpen24Hours)
            $("#closed-" + currentDay.name).prop("checked", isMondayClosed)
            $("#none-" + currentDay.name).prop("checked", mondayHasNone)
            if (singleLocationMode) {
              return {
                ...currentDay,
                isClosed: isMondayClosed,
                hasNone: mondayHasNone,
                open24Hours: mondayOpen24Hours,
                hourBlocks: mondayHours.map(x => x)
              }
            } else {
              $("#" + currentDay.name).prop("checked", true) // Check the selected box for the day

              return {
                ...currentDay,
                isClosed: isMondayClosed,
                hasNone: mondayHasNone,
                open24Hours: mondayOpen24Hours,
                hourBlocks: mondayHours.map(x => x),
                selected: true
              }
            }

          })

          setDaysModel(updatedDaysModel);
          updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
        }
      });
    }

  }

  const setDayOpen24hours = (day) => (event) => {
    const open24Hours = event.target.checked;

    const updatedDaysModel = daysModel.map(dayModel => {
      return day.name === dayModel.name ? {
        ...dayModel,
        hourBlocks: open24Hours ? [{...open24HoursBlock}] : dayModel.hourBlocks,
        open24Hours
      } : dayModel
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const setDayIsClosed = (day) => (event) => {
    const isClosed = event.target.checked;

    const updatedDaysModel = daysModel.map(dayModel => {
      if(isClosed) {
        // If the location is closed, wipe out all hours and leave one blank segment so the user is aware
        return day.name === dayModel.name ? {...dayModel, hourBlocks: [].concat([defaultHourBlock]), isClosed: isClosed} : dayModel
      } else {
        return day.name === dayModel.name ? {...dayModel, isClosed: isClosed} : dayModel
      }
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const setDayHasNone = (day) => (event) => {
    const hasNone = event.target.checked

    const updatedDaysModel = daysModel.map(dayModel => {
      if(hasNone) {
        // If the location is closed, wipe out all hours and leave one blank segment so the user is aware
        return day.name === dayModel.name ? {...dayModel, hourBlocks: [].concat([defaultHourBlock]), hasNone: hasNone} : dayModel
      } else {
        return day.name === dayModel.name ? {...dayModel, hasNone: hasNone} : dayModel
      }
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  }

  const setHourBlockOpenTime = (day, hourBlockIndex) => (event) => {
    const updatedDaysModel = daysModel.map(dayModel => {
      return day.name === dayModel.name ? {...dayModel, hourBlocks: dayModel.hourBlocks.map((hourBlock, index) => {
        return hourBlockIndex === index ? {...hourBlock, openTime: event.target.value} : hourBlock
      })} : dayModel
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const setHourBlockCloseTime = (day, hourBlockIndex) => (event) => {
    const updatedDaysModel = daysModel.map(dayModel => {
      return day.name === dayModel.name ? {...dayModel, hourBlocks: dayModel.hourBlocks.map((hourBlock, index) => {
        return hourBlockIndex === index ? {...hourBlock, closeTime: event.target.value} : hourBlock
      })} : dayModel
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const addHourBlock = (day) => () => {
    const updatedDaysModel = daysModel.map(dayModel => {
      return day.name === dayModel.name ? {
        ...dayModel,
        hourBlocks: dayModel.hourBlocks.concat([defaultHourBlock])
      } : dayModel;
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  };

  const removeHourBlock = (day) => () => {
    const updatedDaysModel = daysModel.map(dayModel => {
      const isCorrectDay = (day.name === dayModel.name)
      if(isCorrectDay && dayModel.hourBlocks.length > 1) {
        dayModel.hourBlocks.pop()
        return {
          ...dayModel,
          hourBlocks: dayModel.hourBlocks
        }
      } else {
        return {...dayModel}
      }
    });

    setDaysModel(updatedDaysModel);
    updateLocationPatchSection(cleanDaysForPatch(updatedDaysModel))
  }

  if (createMode && !combinedLocationServicesMap.listingManagement) {
    // Only require hours for listing management locations
    setFormIsInvalid(false);
  } else {
    setFormIsInvalid(singleLocationMode && locationPatchHours.length !== 7);
  }

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Daily{!!combinedLocationServicesMap.listingManagement && "*"}</h5>
    <div>Only selected days will be updated</div>
    <form className="form-inline card-spacer-top">
      <table className="bulk-location-editor-hours">
        <tbody>
        {daysModel.map((day, index) => {
          return <Fragment key={index}>
            <tr className="card-spacer-top">
              <td>
                <div className={"" + (!singleLocationMode ? " custom-control custom-checkbox" : "")}>
                  {!singleLocationMode && <input type="checkbox" id={day.name} className={!singleLocationMode ? "custom-control-input" : ""} defaultChecked={day.selected} value={day.selected} onClick={setDaySelected(day)}/>}
                  <label style={{"justifyContent": "left"}} className={!singleLocationMode ? "custom-control-label" : ""} htmlFor={day.name}>{" " + day.name}</label>
                </div>
              </td>
              <td>
                from
              </td>
              <td>
                {day.hourBlocks.slice(0, 1).map((openHourBlock, hourBlockIndex) => {
                  return <div key={hourBlockIndex}>
                    <input className="form-control" disabled={!day.selected || day.open24Hours || day.isClosed || day.hasNone} type="time" value={openHourBlock.openTime} onChange={setHourBlockOpenTime(day, hourBlockIndex)} />
                    {" "}to <input className="form-control" disabled={!day.selected || day.open24Hours || day.isClosed || day.hasNone} type="time" value={openHourBlock.closeTime === "24:00" ? "00:00" : openHourBlock.closeTime} onChange={setHourBlockCloseTime(day, hourBlockIndex)} />
                  </div>
                })}
              </td>
              <td>
                <div className="custom-control custom-checkbox control-spacer-left">
                  <input type="checkbox" id={"open24hours-" + day.name} className="custom-control-input" disabled={!day.selected || day.isClosed || day.hasNone} value={day.open24Hours} defaultChecked={day.open24Hours} onClick={setDayOpen24hours(day)}/>
                  <label className="custom-control-label" htmlFor={"open24hours-" + day.name}>Open 24 Hours</label>
                </div>
              </td>
              <td>
                <div className="custom-control custom-checkbox control-spacer-left">
                  <input type="checkbox" id={"closed-" + day.name} className="custom-control-input" disabled={!day.selected || day.open24Hours || day.hasNone} value={day.isClosed} defaultChecked={day.isClosed} onClick={setDayIsClosed(day)}/>
                  <label className="custom-control-label" htmlFor={"closed-" + day.name}>Closed</label>
                </div>
              </td>
              <td>
                <div className="custom-control custom-checkbox control-spacer-left">
                  <input type="checkbox" id={"none-" + day.name} name="hasNoneCheckbox" className="custom-control-input" disabled={!day.selected || day.open24Hours || day.isClosed} value={day.hasNone} defaultChecked={day.hasNone} onClick={setDayHasNone(day)}/>
                  <label className="custom-control-label" htmlFor={"none-" + day.name}>None</label>
                </div>
              </td>
            </tr>
            {day.hourBlocks.slice(1, day.hourBlocks.length).map((openHourBlock, offsetIndex) => {
              const hourBlockIndex = offsetIndex + 1;
              return <tr className="card-spacer-top">
                <td />
                <td>
                  from
                </td>
                <td>
                  <div key={hourBlockIndex}>
                    <input className="form-control" disabled={!day.selected || day.open24Hours || day.isClosed} type="time"
                                value={openHourBlock.openTime} onChange={setHourBlockOpenTime(day, hourBlockIndex)}/>
                    {" "}to <input className="form-control" disabled={!day.selected || day.open24Hours || day.isClosed} type="time"
                              value={openHourBlock.closeTime === "24:00" ? "00:00" : openHourBlock.closeTime} onChange={setHourBlockCloseTime(day, hourBlockIndex)}/>
                  </div>
                </td>
                <td>
                </td>
                <td>
                </td>
              </tr>
            })}
            <tr>
              {singleLocationMode && <td />}
              <td />
              <td>
                <button type="button" className="btn btn-secondary" disabled={!day.selected || day.open24Hours || day.isClosed || day.hasNone} onClick={addHourBlock(day)}>
                  <i className="far fa-plus" />
                </button>
                <span>&nbsp;</span>
                <button type="button" className="btn btn-primary" disabled={!day.selected || day.open24Hours || day.isClosed || day.hasNone} onClick={removeHourBlock(day)}>
                  <i className="fas fa-minus" />
                </button>
              </td>
              <td />
              <td />
            </tr>
            {day.name === "Monday" && <tr>
              <td />
              <td />
              <td>
                <div>
                  <span ng-show="vm.isHourCloningEnabled">
                    <i className="fas fa-clone" aria-hidden="true" onClick={setAllDaysSameAsMonday()}></i>
                    <span onClick={setAllDaysSameAsMonday()}>&nbsp;Clone Monday hours to all days</span>
                  </span>
                </div>
              </td>
            </tr>}
          </Fragment>
        })}
        </tbody>
      </table>
    </form>
  </div>
}

export default BulkLocationEditorHours